import {
  OPERATION_DETAILS_DIALOG_CLASSNAME,
  OperationHistoryDetailsModal,
} from '@/entities/operation';
import { Dialog, DialogContent } from '@/shared/components';
import type { OperationDto } from '@/shared/types';

type Props = {
  operation: OperationDto;
  onClose: () => void;
  onStatusChange?: () => void;
};

export const OperationDetailsDialog = ({
  operation,
  onClose,
  onStatusChange,
}: Props) => (
  <Dialog open onOpenChange={isOpen => !isOpen && onClose()}>
    <DialogContent
      showCloseButton={false}
      aria-describedby={undefined}
      className={OPERATION_DETAILS_DIALOG_CLASSNAME}>
      <OperationHistoryDetailsModal
        key={operation.operaionid}
        operation={operation}
        onClose={onClose}
        onStatusChange={onStatusChange}
      />
    </DialogContent>
  </Dialog>
);
